import { TypographyOptions } from '@material-ui/core/styles/createTypography'

declare module '@material-ui/core/styles/createTypography' {
  interface Typography {
    lato: {
      main: React.CSSProperties
      captionBold: React.CSSProperties
      body1: React.CSSProperties
      body1Bold: React.CSSProperties
    }
  }
  interface TypographyOptions {
    lato?: {
      main?: React.CSSProperties
      captionBold?: React.CSSProperties
      body1?: React.CSSProperties
      body1Bold?: React.CSSProperties
    }
  }
}

export const typography: TypographyOptions = {
  button: {
    textTransform: 'none',
  },
  lato: {
    main: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 17,
      lineHeight: '22.1px',
      letterSpacing: '0.5px',
    },
    captionBold: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 13,
      lineHeight: '16.9px',
      letterSpacing: '2%',
    },
    body1: {
      fontFamily: 'Lato',
      fontSize: 17,
      lineHeight: '26.1px',
      letterSpacing: '0.5px',
    },
    body1Bold: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 17,
      lineHeight: '22.1px',
      letterSpacing: '0.5px',
    },
  },
}
